import styled from 'styled-components';
import withStyles from '@material-ui/core/styles/withStyles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

// CONSTANTS
import { theme } from '../../constants/theme';

const SwipeableDrawerStyled = withStyles({
  root: {
    zIndex: 99999
  },
  paperAnchorBottom: {
    fontFamily: 'Clan Pro',
    fontWeight: theme.weights.regular,
    padding: '28px 32px 8px',
    border: `1px solid ${theme.colors.secondary.gray600}`,
    boxSizing: 'border-box',
    borderRadius: '16px 16px 0px 0px',
    background: theme.colors.primary.white
  }
})(SwipeableDrawer);

export const SlideUpContainer = styled(SwipeableDrawerStyled)<{ black?: boolean }>`
  ${({ black }) =>
    black &&
    `
    .MuiPaper-root {
      width: 100vw;
      background: ${theme.colors.primary.black};
      border: 1px solid ${theme.colors.primary.black};
      color: ${theme.colors.primary.white};
    }
  `}
`;

export const Indicator = styled.div`
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  margin: auto;
  width: 48px;
  height: 4px;
  background: ${theme.colors.secondary.gray400};
  border-radius: 2px;
`;
